import React from 'react';

interface FieldWrapperProps {
  label: string;
  required?: boolean;
  error?: string;
  helper?: string;
  children: React.ReactNode;
  htmlFor?: string;
}

export default function FieldWrapper({
  label,
  required,
  error,
  helper,
  children,
  htmlFor,
}: FieldWrapperProps) {
  return (
    <div className="flex flex-col gap-0">
      <label className="field-label" htmlFor={htmlFor}>
        {label}
        {required && <span className="required-star" aria-hidden="true">*</span>}
      </label>
      {helper && !error && (
        <p className="field-helper" style={{ marginBottom: '0.375rem' }}>
          {helper}
        </p>
      )}
      {children}
      {error && (
        <p className="field-error" role="alert">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="flex-shrink-0 mt-0.5"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
}